import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useSiteSelectorQuery from 'queries/useSiteSelectorQuery';
import Image from '@activebrands/core-web/components/Image';
import media from '@activebrands/core-web/config/media';
import { OVERLAY_ID } from '@activebrands/core-web/config/overlay';
import OverlayTrigger from '@activebrands/core-web/libs/OverlayTrigger';
import { styled } from '@activebrands/core-web/libs/styletron';
import { getFocusRingStyles } from '@activebrands/core-web/utils/style-functions/get-focus-styles';
import Paragraph from 'components/text/Paragraph';

const MenuItem = styled('div', {
    width: '100%',
    wordWrap: 'break-word',
});
const SelectorWrapper = styled('div', {
    width: '100%',
});
const SelectButton = styled('button', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px 8px 12px',

    width: '100%',
    lineHeight: '100%',
    [media.min['tablet.sm']]: {
        justifyContent: 'flex-start',
    },
    ...getFocusRingStyles(),
});

const ContentWrapper = styled('div', {
    display: 'flex',
});

const IconWrapper = styled('div', {
    marginRight: '16px',
    borderRadius: '60px',
    width: '16px',
    height: '16px',
    overflow: 'hidden',
});

const SiteSelectorButton = ({ alternateHrefs = [] }) => {
    const { siteSelectorLinks } = useSiteSelectorQuery();
    const aliasId = useSelector(state => state.application.aliasId);
    const currentSite = siteSelectorLinks.find(site => site.id == aliasId);

    return (
        <MenuItem>
            <SelectorWrapper>
                <OverlayTrigger overlayId={OVERLAY_ID.SITE_SELECTOR} overlayProps={{ alternateHrefs }}>
                    <SelectButton data-selector="global.footer.country">
                        <ContentWrapper>
                            <IconWrapper>
                                {/* Empty alt is intentional since the flag is decorative */}
                                <Image alt="" sizes={['24px']} src={{ url: currentSite?.icon, width: [16, 48, 72] }} />
                            </IconWrapper>
                            <Paragraph fontKeys="Miscellaneous/14_100">{currentSite?.label}</Paragraph>
                        </ContentWrapper>
                    </SelectButton>
                </OverlayTrigger>
            </SelectorWrapper>
        </MenuItem>
    );
};

SiteSelectorButton.propTypes = {
    alternateHrefs: PropTypes.array,
};

export default SiteSelectorButton;
